import { createTheme } from '@mui/material';
import { ptBR } from '@mui/x-date-pickers/locales/ptBR';

declare module '@mui/material/styles' {
  interface Palette {
    aqua: Palette['primary'];
    neutral: Palette['primary'];
    pastelBlue: Palette['primary'];
    emerald: Palette['primary'];
    // error: Palette['primary'];
    // warning: Palette['primary'];
    // success: Palette['primary'];
    // info: Palette['primary'];
  }

  interface PaletteOptions {
    aqua?: PaletteOptions['primary'];
    neutral?: PaletteOptions['primary'];
    pastelBlue?: PaletteOptions['primary'];
    emerald?: PaletteOptions['primary'];
    // error?: PaletteOptions['primary'];
    // warning?: PaletteOptions['primary'];
    // success?: PaletteOptions['primary'];
    // info?: PaletteOptions['primary'];
  }
}

export const muiTheme = createTheme(
  {
    palette: {
      text: {
        primary: '#676767',
        // secondary: '#777777',
      },
      primary: {
        main: '#26849D',
        light: '#41B2D0',
        dark: '#1B677B',
        contrastText: '#fff',
      },
      secondary: {
        main: '#79C8D4',
      },
      emerald: {
        main: '#327E5E',
        light: '#E9FAF0',
        contrastText: '#fff',
      },
      // info: {
      //   main: '#F5F7FA',
      // },
      aqua: {
        main: '#0ABCA8',
        light: '#5FE2D3',
        dark: '#089d8f',
        contrastText: '#ffffff',
      },
      neutral: {
        light: "EFF1F2",
        main: "#CCCCD6",
      },
      pastelBlue: {
        main: '#CCF1FB',
        light: '#BCE1E7',
        contrastText: '#26849D',
      },
      error: {
        main: '#EE6B6B',
        light: '#F3E9E9',
        dark: '#FFAAAA',
      },
      warning: {
        dark: '#FFDD6D',
        light: '#FFF3CB',
        main: '#C9B46E',
      },
      success: {
        dark: '#8DEBBF',
        light: '#CCFFE7',
        main: '#25B070',
      },
      info: {
        main: '#73D3E1',
        light: '#E0FBFF',
        dark: '#26849D',
      }
    },
    typography: {
      fontFamily: '"Onest", "Arial", sans-serif',
      h1: {
        fontFamily: '"Onest", "Arial", sans-serif',
      },
      h2: {
        fontFamily: '"Onest", "Arial", sans-serif',
      },
      body1: {
        fontFamily: '"Onest", "Arial", sans-serif',
      },
    },
    components: {
      MuiOutlinedInput: {
        styleOverrides: {
          root: {
            '& fieldset': {
              borderColor: '#CCCCD6',
              borderRadius: '11px',
            },
            '&.Mui-focused fieldset': {
              borderColor: '#26849D',
            },
            '&:hover fieldset': {
              borderColor: '#26849D',
            },
            backgroundColor: 'white',
            borderRadius: '11px',
          },
        },
      },
      MuiButton: {
        styleOverrides: {
          root: {
            textTransform: 'none',
            borderRadius: '11px',
          },
        },
      },
      MuiSelect: {
        styleOverrides: {
          root: {
            '&.MuiOutlinedInput-root': {
              '& fieldset': {
                borderColor: '#CCCCD6',
              },
              '&.Mui-focused fieldset': {
                borderColor: '#26849D',
              },
              '&:hover fieldset': {
                borderColor: '#26849D',
              },
            },
          },
        },
      },
      // MuiMenu: {
      //   styleOverrides: {
      //     paper: {
      //       backgroundColor: '#F5F7FA',
      //       borderRadius: '11px',
      //     },
      //   },
      // },
      MuiCssBaseline: {
        styleOverrides: {
          body: {
            backgroundColor: '#F5F7FA',
            height: '100vh',
            fontFamily: '"Onest", "Arial", sans-serif',
          },
          '*': {
            borderColor: '#CCCCD6'
          },
        },
      },
    },
  },
  ptBR,
);
